export const QUESTION_TYPES = ['Text', 'Multiple Choice', 'Multiple Choice 1-10'];

export const COLLEAGUE_TYPES = ['Superior', 'Peer', 'Subordinate'];

export const EMAIL_METHODS = ['Default', 'Mailgun', 'Gmail', 'Export'];
